import Layout from 'core/Layout/Layout';
export default Layout;
